import Api from '@/repository/api';
import { ICategoryClientRepository } from '@/repository/categoryClient/CategoryClientRepository.types';
import { CategoryResponseType } from '@/entity/category/category.types';
import { CategoryR } from '@/entity/category/category';
import store from '@/store';
import {getStudioId} from '@/UI/lib/state';
//import CategoryClient from '@/entity/category/category';

export default class CategoryClientRepository implements ICategoryClientRepository {
    async fetchAll(data?: FormData): Promise<CategoryR> {
        const response = await Api.get(`/clients/category/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                const query = new URLSearchParams(params);
                const salon = getStudioId({$store: store});
                if (salon && !query.has('filter[salon_id]')) query.set('filter[salon_id]', String(salon));
                return query.toString();
            },
        });
        /* const respData = response.data as CategoryClientResponseType[];
        return respData.map((role: CategoryClientResponseType) => new CategoryClient(role)); */

        const responseData = response.data as CategoryResponseType;
        return new CategoryR(responseData);
    }
}
